import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {
  subjects as S,
  permissionTypes as T
} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {can} from '../../../_common/components/Permissions';
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';
import {useDeleteItemContext} from "../../contexts/DeleteItemContext";

const PopupDeleteItem = () => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const {id, handleSubmit} = useDeleteItemContext();
  const intl = useIntl();
  const header = intl.formatMessage({
    id: 'price-catalog-page-delete-header',
    defaultMessage: `Delete item ${id}?`
  }, {id});
  const isDisabled = !can(T.FULL, S.PRICE_CATALOG_PAGE) || !id;

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'error'}
        title={TTS.DELETE}
        disabled={isDisabled}
        onClick={handleShowModal}
        label={<img src={toAbsoluteUrl('media/common/Delete_red.svg')} alt="d"/>}
        customClassnames={'mx-2'}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
        <>
          <ModalHeader header={header}/>
          <ModalButtonsContainer customClassnames={largeButtonsPadding}>
            <ButtonAction
              variant={'cancel'}
              label={intl.formatMessage({id: 'button-decline', defaultMessage: 'Decline'})}
              onClick={handleCloseModal}
              customClassnames={buttonCancel}
            />
            <ButtonAction
              label={intl.formatMessage({id: 'button-delete', defaultMessage: 'Delete'})}
              useIcon={'/media/common/Check-in-circle_white.svg'}
              onClick={async () => {
                await handleSubmit();
                handleCloseModal();
              }}
              customClassnames={buttonSubmit}
            />
          </ModalButtonsContainer>
        </>
      </ModalContainer>
    </>
  );
};

export default PopupDeleteItem;
